import { render, staticRenderFns } from "./InterviewPreviewImportancePoint.vue?vue&type=template&id=3bb94691&scoped=true"
import script from "./InterviewPreviewImportancePoint.vue?vue&type=script&lang=js"
export * from "./InterviewPreviewImportancePoint.vue?vue&type=script&lang=js"
import style0 from "./InterviewPreviewImportancePoint.vue?vue&type=style&index=0&id=3bb94691&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb94691",
  null
  
)

export default component.exports